module.exports = __webpack_public_path__ + "media/assets/faria_products/FARIA1STD-dc300facd56310b9dc860a700ca76b5656a8b79da6c46e65a7547ba544edc69e.png";